import { Divider, Grid } from "@mui/joy";
import DarkTypography from "../../../common/DarkTypography";
import DarkInput from "../../../common/DarkInput";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { AddIcon, SDelete } from "../../../../styles/StyledMUI";
import { colorTokens } from "../../../../styles/globalStyles";
import type { TrainingTemplate, Card } from "../../../../api/training/Training.typed";

const cardRowInputSx = {
  backgroundColor: colorTokens.bg.surface,
  border: `1px solid ${colorTokens.border.default}`,
  color: colorTokens.text.primary,
};

type Props = {
  selected: TrainingTemplate;
  newCardName: string;
  onNewCardNameChange: (value: string) => void;
  onAddCard: () => void;
  onRemoveCard: (index: number) => void;
  canEdit: boolean;
};

export default function TrainingTemplateCardsBlock(props: Props) {
  const { selected, newCardName, onNewCardNameChange, onAddCard, onRemoveCard, canEdit } = props;

  return (
    <Grid xs={12}>
      <Divider sx={{ marginY: 2 }} />
      <DarkTypography sx={{ mb: 2 }}>Cartes</DarkTypography>
      {(selected.Cards?.Card ?? []).map((card: Card, index: number) => (
        <Grid container spacing={2} key={`${card.Organisation}-${index}`} alignItems="center">
          <Grid xs={10}>
            <DarkInput value={card.Organisation} fullWidth readOnly size="sm" sx={cardRowInputSx} />
          </Grid>
          <Grid xs={2}>
            <IconButtonCTA
              ctaVariant="danger"
              aria-label="Supprimer la carte"
              onClick={() => onRemoveCard(index)}
              disabled={!canEdit}
            >
              <SDelete />
            </IconButtonCTA>
          </Grid>
        </Grid>
      ))}
      <Grid container spacing={2} sx={{ marginTop: 2 }} alignItems="center">
        <Grid xs={10}>
          <DarkInput
            placeholder="Ajouter une organisation"
            value={newCardName}
            onChange={(event) => onNewCardNameChange(event.target.value)}
            fullWidth
            size="sm"
            sx={cardRowInputSx}
          />
        </Grid>
        <Grid xs={2}>
          <IconButtonCTA
            ctaVariant="accent"
            aria-label="Ajouter une carte"
            onClick={onAddCard}
            size="sm"
            disabled={!canEdit}
          >
            <AddIcon />
          </IconButtonCTA>
        </Grid>
      </Grid>
    </Grid>
  );
}
